import type { ViewQueryRecordNode } from '@salescore/core'
import * as React from 'react'
import { useContext } from 'react'

import type {
  RecordNodePath,
  useSetUpsertViewRecordsByPath,
} from '../../recoil/records/mutations/upsertViewRecordsByPathMutation'

interface ViewUIRecordNodeContextProperties {
  recordNode?: ViewQueryRecordNode
  recordNodePath: RecordNodePath
  upsertViewRecordsByPath: ReturnType<typeof useSetUpsertViewRecordsByPath>
}

export class ViewUIRecordNodeContextClass {
  public state: ViewUIRecordNodeContextProperties

  public constructor(state: ViewUIRecordNodeContextProperties) {
    this.state = state
  }

  public selectors() {
    return {
      getValue: (fieldName: string) => this.state.recordNode?.attributes[fieldName],
    }
  }

  public mutations() {
    return {
      onChange: ({ fieldName, value }: { fieldName: string; value: unknown }) => {
        this.state.upsertViewRecordsByPath({
          recordChanges: [
            {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              id: this.state.recordNode!.id!,
              recordNodePath: this.state.recordNodePath,
              fieldName,
              value,
            },
          ],
        })
      },
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
export const ViewUIRecordNodeContext = React.createContext<ViewUIRecordNodeContextClass>(undefined as never)

// どういう形で露出させるか検討中。。
export const useViewUIRecordNodeContext = () => {
  const c = useContext(ViewUIRecordNodeContext)

  return {
    ...c.state,
    ...c.selectors(),
    ...c.mutations(),
  }
}
